import { LOCALES } from 'i18n/locales';

export const workpackSummaryIntl = {
    [LOCALES.ENGLISH]: {
        'workpackSummary.pdfType': 'PDF type',
        'workpackSummary.purpose': 'Purpose',
        'workpackSummary.description': 'Description',
        'workpackSummary.details': 'Details',
        'workpackSummary.name': 'Title',
        'workpackSummary.preview': 'Preview - UPDATE THE MAP VIEW HERE',
        'workpackSummary.paperOrientation': 'Paper orientation',
        'workpackSummary.scale': 'Scaling',
        'workpackSummary.paperSize': 'Paper size',
        'workpackSummary.mapScale': 'Map scale',
        'workpackSummary.electricityVoltageColourCoding': 'Electricity: Voltage colour coding',
        'workpackSummary.electricityVoltageColourCoding.on': 'On',
        'workpackSummary.electricityVoltageColourCoding.off': 'Off',
        'workpackSummary.disclaimer.title': 'Important',
        'workpackSummary.disclaimer.line1': 'Work packs are for information purposes only. If you are planning works, please use the Make Enquiry feature instead.',
        'workpackSummary.disclaimer.line2': 'Information on NUAR is for general guidance only and is given without warranty. We cannot guarantee data accuracy and completeness.',
        'workpackSummary.disclaimer.line3': 'Data is supplied to NUAR by participating asset owners. It should be anticipated that some asset records may not be displayed.',
        'workpackSummary.disclaimer.line4': 'Please ensure all <linkHsg47>HSG47 safety protocols</linkHsg47> are followed.',
        'workpackSummary.termsAndConditions': 'By creating this work pack, you are agreeing to the terms and conditions of the <linkEndUser>end user terms</linkEndUser>. Relevant asset owners and their third parties may be notified of the creation of this work pack.'
    },
    [LOCALES.WELSH]: {
        'workpackSummary.pdfType': '[PDF type]',
        'workpackSummary.purpose': '[Purpose]',
        'workpackSummary.description': '[Description]',
        'workpackSummary.details': '[Details]',
        'workpackSummary.name': '[Title]',
        'workpackSummary.preview': '[Preview - UPDATE THE MAP VIEW HERE]',
        'workpackSummary.paperOrientation': '[Paper orientation]',
        'workpackSummary.scale': '[Scaling]',
        'workpackSummary.paperSize': '[Paper size]',
        'workpackSummary.mapScale': '[Map scale]',
        'workpackSummary.electricityVoltageColourCoding': '[Electricity: Voltage colour coding]',
        'workpackSummary.electricityVoltageColourCoding.on': '[On]',
        'workpackSummary.electricityVoltageColourCoding.off': '[Off]',
        'workpackSummary.disclaimer.title': '[Important]',
        'workpackSummary.disclaimer.line1': '[Work packs are for information purposes only. If you are planning works, please use the Make Enquiry feature instead.]',
        'workpackSummary.disclaimer.line2': '[Information on NUAR is for general guidance only and is given without warranty. We cannot guarantee data accuracy and completeness.]',
        'workpackSummary.disclaimer.line3': '[Data is supplied to NUAR by participating asset owners. It should be anticipated that some asset records may not be displayed.]',
        'workpackSummary.disclaimer.line4': '[Please ensure all <linkHsg47>HSG47 safety protocols</linkHsg47> are followed.]',
        'workpackSummary.termsAndConditions': '[By creating this work pack, you are agreeing to the terms and conditions of the <linkEndUser>end user terms</linkEndUser>. Relevant asset owners and their third parties may be notified of the creation of this work pack.]'
    }
};
